import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import './Partners.css';

// Placeholder data for partners - in a real implementation, this would come from an API
const dummyPartners = [
  {
    id: 1,
    name: 'MultiSport',
    logo: 'multisport', // Using string identifier for CSS class usage
    website: 'https://www.multi-sport.sk/',
    color: '#e20613' // Brand color
  },
  {
    id: 2,
    name: 'Soundra Therapy',
    logo: 'soundra', // Using string identifier for CSS class usage
    website: 'https://www.soundratherapy.sk/',
    color: '#000000' // Brand color
  },
  {
    id: 3,
    name: 'UpBalansea',
    logo: 'upbalance', // Using string identifier for CSS class usage
    website: 'https://www.upbalansea.sk/',
    color: '#008fc9' // Brand color
  },
  {
    id: 4,
    name: 'Ammyla',
    logo: 'ammyla', // Using string identifier for CSS class usage
    website: 'https://www.ammyla.sk/',
    color: '#666666' // Brand color
  }
];

const Partners = () => {
  const { t } = useTranslation();
  const { currentTheme, themes } = useTheme();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In a real implementation, this would fetch partners from an API
    // For now, we'll just simulate a loading delay with the dummy data
    const timer = setTimeout(() => {
      setPartners(dummyPartners);
      setLoading(false);
    }, 300);

    // Load Cormorant Garamond font
    if (!document.querySelector('link[href*="fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700"]')) {
      const garamondLink = document.createElement('link');
      garamondLink.rel = 'stylesheet';
      garamondLink.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600;700&display=swap';
      document.head.appendChild(garamondLink);
    }

    return () => clearTimeout(timer);
  }, []);

  // Function to get initials for a company name (fallback if logo fails to load)
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase();
  };

  if (loading) {
    return (
      <section className="partners-section">
        <div className="container">
          <div className="loading-spinner">{t('loader.loading')}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="partners-section">
      <div className="container">
        <h2 className="partners-heading">{t('partners.our_partners')}</h2>
        <p className="partners-subheading">{t('partners.accept_payment_methods')}</p>
        
        <div className="partners-container">
          {partners.map(partner => (
            <a 
              key={partner.id} 
              href={partner.website} 
              target="_blank" 
              rel="noopener noreferrer"
              className="partner-item"
              aria-label={`${partner.name} - ${t('partners.visit_website')}`}
            >
              <div className="partner-logo-container">
                {partner.logo ? (
                  <div className={`partner-logo-${partner.logo}`}></div>
                ) : (
                  <div 
                    className="partner-name-fallback" 
                    style={{ 
                      display: 'flex',
                      backgroundColor: partner.color || 'rgba(var(--primary-color-rgb), 0.1)',
                      color: '#ffffff'
                    }}
                  >
                    {getInitials(partner.name)}
                  </div>
                )}
              </div>
              <div className="partner-name">
                {partner.name}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners; 